import { useEffect, useState } from 'react';

const useDataPaginate = (listLength, recordsPerPageInitial, currentPageInitial, callback, messageGenerator) => {
    const [recordsPerPage, setRecordsPerPage] = useState(recordsPerPageInitial);
    const [currentPage, setCurrentPage] = useState(currentPageInitial);
    const [numberPages, setNumberPages] = useState(Math.ceil(listLength / recordsPerPageInitial));
    const [limits, setLimits] = useState([1, recordsPerPageInitial]);
    const [paginateMessage, setPaginateMessage] = useState(null);

    const changePage = (newPage) => {
        if (newPage < 1) {
            setCurrentPage(1);
        } else if (newPage > listLength) {
            setCurrentPage(listLength);
        } else {
            setCurrentPage(newPage);
        }

        let newLimits = [];        
        if (newPage === numberPages) {
            newLimits = [recordsPerPage * (newPage - 1) + 1, listLength];
        } else {
            newLimits = [recordsPerPage * (newPage - 1) + 1, recordsPerPage * newPage];
        }

        setLimits(newLimits);
        callback({ page: newPage, pageSize: recordsPerPage, listLength, limits });
        setPaginateMessage(messageGenerator({listLength, limits: newLimits}));
    };

    const changeRecords = (newRecordsPerPage) => {
        if (newRecordsPerPage) {
            setCurrentPage(1);
            setRecordsPerPage(newRecordsPerPage);
            setNumberPages(Math.ceil(listLength / newRecordsPerPage));
            setLimits([1, newRecordsPerPage]);
        }
        callback({ page: 1, pageSize: newRecordsPerPage, listLength, limits });
    };

    useEffect(() => {
        setCurrentPage(1);
        setNumberPages(Math.ceil(listLength / recordsPerPage));
        setLimits([1, recordsPerPage]);
        callback({ page: 1, pageSize: recordsPerPage, listLength, limits });
        setPaginateMessage(messageGenerator({listLength, limits: [1, recordsPerPage]}));
    }, [listLength]);

    useEffect(() => {
        setPaginateMessage(messageGenerator({listLength, limits}));
    }, []);

    return {
        recordsPerPage,
        currentPage,
        numberPages,
        paginateMessage,
        changePage,
        changeRecords,
    };
};

export {
    useDataPaginate,
};